import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { LoadData, GetDetailList, saveOrderInfo, AuditOrder, UnCheckBillOrder as _UnCheckBillOrder, CancelBill } from '@/api/MaintainDeliveryNote2';
import { mapActions, mapGetters } from 'vuex';
import dayjs from 'dayjs';
import moment from 'moment';
import 'moment/locale/zh-cn';
import util from '@/libs/util';
import addOrderRowDialog from './AddOrderRowDialog';
moment.locale('zh-cn');
export default {
  components: {
    addOrderRowDialog: addOrderRowDialog
  },
  mounted: function mounted() {
    var year = new Date().getFullYear();

    for (var i = year - 3; i <= year + 3; i++) {
      this.YearList.push({
        value: i,
        label: i
      });
    }

    console.log(this.YearList);
  },
  data: function data() {
    var DELIVERY_QTYValid = function DELIVERY_QTYValid(cellValue) {
      var DELIVERY_QTY = Number(cellValue.DELIVERY_QTY);

      if (DELIVERY_QTY === 0) {
        return new Error('送货数量不能为0');
      }
    };

    var SPQValid = function SPQValid(cellValue) {
      // console.log('cellValue',cellValue);
      // console.log(cellValue.row.DELIVERY_QTY);
      var SPQ = Number(cellValue.cellValue);
      var QTY = cellValue.row.DELIVERY_QTY; // console.log('SPQ',SPQ);
      // console.log('QTY',QTY);

      if (SPQ === 0 || SPQ < 0) {
        return new Error('内包装数量不能为0或少于0');
      } else if (SPQ > QTY) {
        return new Error('内包装数量不能大于送货数量');
      }
    };

    var PACKING_QTYValid = function PACKING_QTYValid(cellValue) {
      // console.log('cellValue',cellValue);
      // console.log(cellValue.row.DELIVERY_QTY);
      var PACKING_QTY = Number(cellValue.cellValue);
      var QTY = cellValue.row.DELIVERY_QTY; // console.log('SPQ',SPQ);
      // console.log('QTY',QTY);

      if (PACKING_QTY < 0) {
        return new Error('外包装数量不能为负数');
      } else if (PACKING_QTY > QTY) {
        return new Error('外包装数量不能大于送货数量');
      }
    };

    return {
      tabelData: [],
      columnConfig: {
        resizable: true
      },
      pageInfo: {
        TotalCount: null,
        size: null,
        current: null
      },
      loading: false,
      editConfig: {
        trigger: null,
        mode: null,
        showStatus: true
      },
      tableHeaderInfo: {},
      YearList: [],
      canEdit: false,
      vxeRules: {
        DELIVERY_QTY: [{
          required: true,
          message: '送货数量必须填写'
        }, {
          validator: DELIVERY_QTYValid
        }],
        SPQ: [{
          required: true,
          message: '内箱包装数量必须填写'
        }, {
          validator: SPQValid
        }],
        PACKING_QTY: [{
          validator: PACKING_QTYValid
        }]
      },
      isShowaddOrderRowDialog: false,
      isShowPageBar: true,
      isShowOptionColumn: false,
      userInfo: JSON.parse(util.cookies.get('userInfo'))
    };
  },
  methods: {
    // 获取当前时间
    getNowDate: function getNowDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y.toString() + m.toString() + d.toString();
    },
    countDate: function countDate(row) {
      var year = row.year,
          week = row.week,
          date = row.date;

      if (week === '' || date === '' || week === undefined || date === undefined || year === '' || year === undefined) {
        return false;
      }

      var w = moment().isoWeekYear(year).isoWeek(week).days(0);
      w = moment(w).format('YYYY-M-D'); // console.log('@@@@', moment().isoWeekYear(year))

      var day = moment(w).add(row.date, 'd').format('YYYY-M-D');
      var gg = moment(day).format('gg');

      if (week <= 9) {
        row.ATTRIBUTE7 = "".concat(gg, "0").concat(week);
      } else {
        row.ATTRIBUTE7 = "".concat(gg).concat(week);
      }

      row.ATTRIBUTE6 = "".concat(year, "\u5E74\u7B2C").concat(week, "\u5468\u7B2C").concat(date, "\u5929"); // console.log('day', day)
      // console.log('row.ATTRIBUTE6', row.ATTRIBUTE6)

      row.DATE_CODE = day;
      var now = this.getNowDate(new Date());

      if (week <= 9) {
        row.LOT_NO = gg + '0' + week + now;
      } else {
        row.LOT_NO = gg + week + now;
      } // console.log(row.LOT_NO)

    },
    countWeek: function countWeek(row) {
      var day = row.DATE_CODE;
      var now = this.getNowDate(new Date());
      var year = moment(day).format('gggg');
      console.log(moment(day).format('gggg W d'));
      var W = moment(day).format('W');
      var ww = moment(day).format('ww');
      var gg = moment(day).format('gg');
      var d = moment(day).format('E');
      row.year = year;
      row.week = W;
      row.date = d;

      if (W <= 9) {
        row.LOT_NO = gg + '0' + W + now;
      } else {
        row.LOT_NO = gg + W + now;
      }

      row.ATTRIBUTE7 = "".concat(gg).concat(ww);
      row.ATTRIBUTE6 = "".concat(year, "\u5E74\u7B2C").concat(W, "\u5468\u7B2C").concat(d, "\u5929");
      console.log(row.LOT_NO);
    },
    // 打开新增明细dialog
    openAddOrderRowDialog: function openAddOrderRowDialog(VENDOR_CODE) {
      var _this = this;

      this.isShowaddOrderRowDialog = true;
      this.$nextTick(function () {
        var currentRow = _this.$refs.vxeTable.getTableData().visibleData; // 当前表格的row


        _this.$refs.addOrderRowDialog.getErpPOlist(VENDOR_CODE, currentRow);
      });
    },
    saveForNewOrder: function saveForNewOrder(tableHeaderInfo) {
      this.tableHeaderInfo = tableHeaderInfo;
      this.saveOrderForAdd();
    },
    // ...mapActions('DeliveryNote/Outsourced',['$setOrderStatu']),
    onClickEditOrder: function onClickEditOrder() {
      this.editConfig.trigger = 'click';
      this.editConfig.mode = 'row';
      this.canEdit = true;
      this.keepSource = true;
      this.isShowOptionColumn = true;
    },
    // 提交保存
    submitSave: function submitSave(tableHeaderInfo) {
      if (tableHeaderInfo) {
        this.tableHeaderInfo = tableHeaderInfo;
        this.saveOrderForEdit();
      }
    },
    setData: function setData(data) {
      this.tableHeaderInfo = data;

      if (data) {
        this.getOrderInfo(data.ID);
      }
    },
    // 点击作废
    CancelBillOrder: function CancelBillOrder(ID) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  ID: ID || _this2.tableHeaderInfo.ID,
                  NewStatus: 1,
                  ORG_CODE: util.cookies.get('ORG_CODE'),
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  Operator: _this2.userInfo.USER_NAME,
                  OperatorDatetime: null
                };

                _this2.$openLoading();

                _context.next = 4;
                return CancelBill(params);

              case 4:
                res = _context.sent;

                _this2.$closeLoading();

                if (res.code === 0) {
                  _this2.$message.success('作废成功');

                  _this2.$emit('upDateTableBar', 3);

                  _this2.$emit('onUpdataOrderStaus');
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 点击反审核
    UnCheckBillOrder: function UnCheckBillOrder(ID) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  ID: ID || _this3.tableHeaderInfo.ID,
                  NewStatus: 1,
                  ORG_CODE: util.cookies.get('ORG_CODE'),
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  Operator: _this3.userInfo.USER_NAME,
                  OperatorDatetime: null
                };

                _this3.$openLoading();

                _context2.next = 4;
                return _UnCheckBillOrder(params);

              case 4:
                res = _context2.sent;

                _this3.$closeLoading();

                if (res.code === 0) {
                  _this3.$message.success('反审核成功');

                  _this3.$emit('upDateTableBar', 1);

                  _this3.$emit('onUpdataOrderStaus');
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 点击审核
    handleAuditOrder: function handleAuditOrder(ID) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  ID: ID || _this4.tableHeaderInfo.ID,
                  NewStatus: 2,
                  ORG_CODE: util.cookies.get('ORG_CODE'),
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  Operator: _this4.userInfo.USER_NAME,
                  OperatorDatetime: null
                };

                _this4.$openLoading();

                _context3.next = 4;
                return AuditOrder(params);

              case 4:
                res = _context3.sent;

                _this4.$closeLoading();

                console.log('params', params);

                if (res.code === 0) {
                  _this4.$message.success('单据审核成功');

                  _this4.$emit('upDateTableBar', 2);

                  _this4.$emit('onUpdataOrderStaus');
                } else {
                  _this4.$message.warning(res.message);
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 点击明细删除
    hanldeDelete: function hanldeDelete(row) {
      var _this5 = this;

      // console.log(row);
      // this.$refs.vxeTable.remove(row)
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.$refs.vxeTable.remove(row);
      }).catch(function () {});
    },
    // 明细dialog确定按钮回调
    cbaddOrderRowDialogSubmit: function cbaddOrderRowDialogSubmit(rowList) {
      var _this6 = this;

      console.log('rowList', rowList);
      rowList.forEach(function (i) {
        _this6.countWeek(i);
      });
      this.$refs.vxeTable.insertAt(rowList, -1); // this.$refs.vxeTable.reloadData(rowList)

      this.editConfig.trigger = 'click';
      this.editConfig.mode = 'row';
      this.canEdit = true;
      this.keepSource = true;
    },
    // 明细dialog关闭
    closeaddOrderRowDialog: function closeaddOrderRowDialog() {
      this.isShowaddOrderRowDialog = false;
    },
    // 保存单据--新增
    saveOrderForAdd: function saveOrderForAdd() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var $table, errMap, InsertRecords, userInfo, MainData, params, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                $table = _this7.$refs.vxeTable;

                if (!$table) {
                  _context4.next = 23;
                  break;
                }

                if (!($table.getTableData().visibleData.length === 0)) {
                  _context4.next = 5;
                  break;
                }

                _this7.$message.warning('需选择单据明细');

                return _context4.abrupt("return");

              case 5:
                _context4.next = 7;
                return $table.validate().catch(function (errMap) {
                  return errMap;
                });

              case 7:
                errMap = _context4.sent;
                console.log('errMap', errMap);

                if (!errMap) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return");

              case 11:
                console.log(_this7.$refs.vxeTable.getRecordset());
                InsertRecords = _this7.$refs.vxeTable.getRecordset().insertRecords;
                userInfo = JSON.parse(util.cookies.get('userInfo'));
                MainData = {
                  ID: 0,
                  CREATORID: userInfo.USER_NAME,
                  ARRIVAL_DATE: _this7.tableHeaderInfo.ARRIVAL_DATE,
                  DELIVERY_DATE: _this7.tableHeaderInfo.DELIVERY_DATE,
                  VENDOR_CODE: _this7.tableHeaderInfo.VENDOR_CODE,
                  VENDOR_NAME: _this7.tableHeaderInfo.VENDOR_NAME,
                  DESCRIPTION: _this7.tableHeaderInfo.DESCRIPTION
                };
                params = {
                  MainData: MainData,
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  InsertRecords: InsertRecords,
                  RemoveRecords: [],
                  UpdateRecords: []
                };
                console.log('保存单据params----新增', params);

                _this7.$openLoading();

                _context4.next = 20;
                return saveOrderInfo(params);

              case 20:
                res = _context4.sent;

                _this7.$closeLoading();

                if (res.code === 0) {
                  _this7.$message.success('新增单据成功');

                  _this7.keepSource = false;
                  _this7.editConfig.trigger = null;
                  _this7.editConfig.mode = null;
                  _this7.canEdit = false;

                  _this7.$emit('cbCreateOrderSuccess', res.data); // this.$setOrderStatu('orderShow')

                } else {
                  _this7.$message.warning(res.message);
                }

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 保存单据--修改
    saveOrderForEdit: function saveOrderForEdit() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var $table, errMap, InsertRecords, RemoveRecords, UpdateRecords, userInfo, MainData, params, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                $table = _this8.$refs.vxeTable; // console.log('$table getTableData',$table.getTableData());

                if (!$table) {
                  _context5.next = 24;
                  break;
                }

                if (!($table.getTableData().visibleData.length === 0)) {
                  _context5.next = 5;
                  break;
                }

                _this8.$message.warning('需选择单据明细');

                return _context5.abrupt("return");

              case 5:
                _context5.next = 7;
                return $table.validate().catch(function (errMap) {
                  return errMap;
                });

              case 7:
                errMap = _context5.sent;
                console.log('errMap', errMap);

                if (!errMap) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return");

              case 11:
                // console.log(this.$refs.vxeTable.getRecordset());
                InsertRecords = _this8.$refs.vxeTable.getRecordset().insertRecords;
                RemoveRecords = _this8.$refs.vxeTable.getRecordset().removeRecords;
                UpdateRecords = _this8.$refs.vxeTable.getRecordset().updateRecords;
                console.log('this.tableHeaderInfo', _this8.tableHeaderInfo);
                userInfo = JSON.parse(util.cookies.get('userInfo'));
                MainData = {
                  ID: _this8.tableHeaderInfo.ID,
                  CREATORID: userInfo.USER_NAME,
                  ARRIVAL_DATE: util.formatTime.transCommDate(_this8.tableHeaderInfo.ARRIVAL_DATE),
                  DELIVERY_DATE: util.formatTime.transCommDate(_this8.tableHeaderInfo.DELIVERY_DATE),
                  // ARRIVAL_DATE:'2022-7-21 18:59:22',
                  // DELIVERY_DATE:'2022-7-21 18:59:22',
                  VENDOR_CODE: _this8.tableHeaderInfo.VENDOR_CODE,
                  VENDOR_NAME: _this8.tableHeaderInfo.VENDOR_NAME,
                  DELIVERY_NO: _this8.tableHeaderInfo.DELIVERY_NO,
                  DESCRIPTION: _this8.tableHeaderInfo.DESCRIPTION
                };
                params = {
                  MainData: MainData,
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  InsertRecords: InsertRecords,
                  RemoveRecords: RemoveRecords,
                  UpdateRecords: UpdateRecords
                }; // console.log('保存单据params',params);

                _this8.$openLoading();

                _context5.next = 21;
                return saveOrderInfo(params);

              case 21:
                res = _context5.sent;

                _this8.$closeLoading();

                if (res.code === 0) {
                  _this8.$message.success('保存数据成功');

                  _this8.keepSource = false;
                  _this8.editConfig.trigger = null;
                  _this8.editConfig.mode = null;
                  _this8.canEdit = false;

                  _this8.$emit('onSuccessSave', _this8.tableHeaderInfo.DELIVERY_NO);

                  _this8.$setOrderStatu('orderShow');
                } else {
                  _this8.$message.warning(res.message);
                }

              case 24:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 点击页码
    handleCurrentChange: function handleCurrentChange(index) {
      this.pageInfo.current = index;
      this.getOrderInfo();
    },
    // 切换页码
    handleSizeChange: function handleSizeChange(value) {
      // console.log(value);
      this.pageInfo.size = value;
      this.getOrderInfo();
    },
    // 获取表头明细
    getTableHeaderData: function getTableHeaderData(data) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                params = {
                  Page: 1,
                  // 当前页
                  Limit: 10,
                  // 分页大小
                  Data: {
                    ORGANIZE_ID: util.cookies.get('ORG_ID'),
                    DELIVERY_NO: data.DELIVERY_NO
                  }
                };
                _context6.next = 3;
                return LoadData(params);

              case 3:
                res = _context6.sent;
                console.log(res);

                if (res.code === 0) {
                  _this9.tableHeaderInfo.DELIVERY_NO = res.data.Items[0].DELIVERY_NO;
                  _this9.tableHeaderInfo.CREATORID = res.data.Items[0].CREATORID;
                  _this9.tableHeaderInfo.DESCRIPTION = res.data.Items[0].DESCRIPTION;
                  _this9.tableHeaderInfo.DELIVERY_DATE = res.data.Items[0].DELIVERY_DATE;
                  _this9.tableHeaderInfo.VENDOR = res.data.Items[0].VENDOR_NAME;
                  _this9.tableHeaderInfo.ARRIVAL_DATE = res.data.Items[0].ARRIVAL_DATE;
                  _this9.tableHeaderInfo.STATUS_Caption = res.data.Items[0].STATUS_Caption;
                  _this9.tableHeaderInfo.VENDOR_CODE = res.data.Items[0].VENDOR_CODE;
                  _this9.tableHeaderInfo.ID = res.data.Items[0].ID;

                  _this9.$emit('upDateTableBar', res.data.Items[0].STATUS);
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 获取单据明细
    getOrderInfo: function getOrderInfo(id) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                params = {
                  MST_ID: id,
                  ORGANIZE_ID: util.cookies.get('ORG_ID') // Page: this.pageInfo.current

                };
                _this10.loading = true;
                _context7.next = 4;
                return GetDetailList(params);

              case 4:
                res = _context7.sent;
                console.log('单据明细 res==>', res);
                _this10.loading = false;

                if (res.code === 0) {
                  _this10.tabelData = res.data;
                  _this10.pageInfo.TotalCount = res.TotalCount;
                }

                _this10.tabelData.forEach(function (i) {
                  if (i.ATTRIBUTE6 !== null) {
                    var yindex = i.ATTRIBUTE6.indexOf('年');
                    var windex = i.ATTRIBUTE6.indexOf('周');
                    var dindex = i.ATTRIBUTE6.indexOf('天');
                    i.year = i.ATTRIBUTE6.substring(0, yindex);
                    i.week = i.ATTRIBUTE6.substring(yindex + 2, windex);
                    i.date = i.ATTRIBUTE6.substring(windex + 2, dindex);
                    console.log(i);
                  }
                });

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  },
  watch: {
    $MaintainDeliveryNote2State: {
      handler: function handler(nawValue) {
        // console.log('nawValue', nawValue)
        if (nawValue === 'listShow') {
          this.tabelData = [];
        } else if (nawValue === 'orderShow') {
          this.isShowOptionColumn = false;
        } else if (nawValue === 'addOrder') {
          this.isShowOptionColumn = true;
        }
      },
      immediate: true
    }
  },
  computed: {// ...mapGetters(['OutsourcedState','userinfo'])
  },
  beforeDestroy: function beforeDestroy() {
    // console.log('销毁');
    this.$setOrderStatu('listShow'); // this.Bus.off('onClickaddOrder')
  }
};